import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { useCourse } from "@domain/lms/course/hooks";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { gap } from "@ui/styles/utils";
import { FoldableChapterProgress } from "./foldableChapterProgress";

interface CourseChaptersProgressProps extends React.HTMLAttributes<HTMLDivElement> {
	courseId: string;
	currentIndex: number;
}
export const CourseChaptersProgress: React.FC<CourseChaptersProgressProps> = ({
	courseId,
	currentIndex,
	...htmlProps
}) => {
	const { result: course, loading } = useCourse(courseId);
	return (
		<Container {...htmlProps}>
			<PrimaryMedium>{I18n.t("course.content.quick_access")}</PrimaryMedium>
			<Content>
				{loading ? (
					<ClipLoader />
				) : course ? (
					course.content.chapters.map((chapter, i) => (
						<FoldableChapterProgress
							isCurrent={i === currentIndex}
							key={i}
							chapter={chapter}
							courseId={courseId}
							chapterIndex={i}
						/>
					))
				) : null}
			</Content>
		</Container>
	);
};

const Container = styled.div`
	${gap(20)};
`;
const Content = styled(RoundedBlock)`
	> :not(:last-child) {
		border-bottom: 1px solid ${({ theme }) => theme.colors.lightgray};
	}
`;
